<div class="TopSVideo">
    <div class="slidesHolder">
        <div class="slides">

            <div class="slide" >
                    <!-- <div class="plusHolder">
                        <div class="plusWrap">
                            <app-add-large [movie]="movie"></app-add-large>
    
                        </div>
                    </div> -->

                <img [src]="!isMobile ? movie.pageBg : movie.pageBg" alt="">
                <video [src]="!isMobile? movie.videoBg : movie.videoBg"
                     #videoEl
                    [poster]="!isMobile ? movie.pageBg : movie.pageBg" [muted]="true" playsInline="true"
                    [autoplay]="isAutoplayVideo" [loop]="true" appVideoHandler ></video>
                <!-- <div class="overlay"></div> -->
                <!-- </a> -->
                <div class="playPauseButton">
                    <app-video-play-pause-button
                        [data]="videoEl"></app-video-play-pause-button>
                </div>


                <!-- <div class="ttWrap" *ngIf="!isMinimal">

                    <div class="tt">
                        <div class="starring">{{movie.CastList[0]}}</div>
                        <div class="title">{{movie.Title}}</div>

                        <div class="buttons">
                            <div class="roundButton white" (click)="onBookNow()">
                                <div class="label">
                                    Book Now
                                </div>
                            </div>

                            
                        </div>
                    </div>
                </div> -->
            </div>
        </div>

    </div>

</div>